import { createContext, useState, useEffect } from "react";

export const LinkContext = createContext();

export const LinkProvider = ({ children }) => {
    const [link, setLink] = useState('#');
    const [loading, setLoading] = useState(true);

    const buildLink = (path) => {
        if (!link || link === '#') return '#';
        return `${link.replace(/\/+$/, '')}${path}`;
    };

    const registerLink = buildLink('/en/register');
    const loginLink = buildLink('/en/login');

    useEffect(() => {
        fetch("/link.php")
            .then(res => {
                if (!res.ok) {
                    throw new Error("Error loading url");
                }
                return res.json();
            })
            .then(data => {
                if (data.url) {
                    setLink(data.url);
                }
            })
            .catch(err => {
                console.error("Error in request link:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <LinkContext.Provider value={{ link: registerLink, registerLink, loginLink, loading }}>
            {children}
        </LinkContext.Provider>
    );
};
